module.exports = __webpack_public_path__ + "img/msg_bg.41ad9760.png";